import script from "./VueMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./VueMenu.vue?vue&type=script&setup=true&lang=js"

import "./VueMenu.vue?vue&type=style&index=0&id=fc71f3e2&scoped=true&lang=css"
import "./VueMenu.vue?vue&type=style&index=1&id=fc71f3e2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc71f3e2"]])

export default __exports__